export default class TraxCaseSelect2Enabler {
  init() {
    const traxCaseSelect = $('#time_entry_form_trax_case_id');
    const traxCaseFromParams = $('#time_entry_form_trax_case_id_from_params');

    traxCaseSelect.select2({
      placeholder: 'Choose a trax case...',
      minimumInputLength: 1,
      width: '100%',
      ajax: {
        url: () => window.junoRoutes.timeEntries.linkToFindTraxCases(),
        dataType: 'json',
        delay: 250,
        cache: true,
        data: (params) => { return { term: params.term } },
        processResults: (data) => {
          return {
            results: $.map(data.trax_cases, (trax_case) => ({ text: trax_case.subject_with_id, id: trax_case.id }))
          };
        }
      }
    });

    if (traxCaseFromParams.length && traxCaseFromParams.val() !== '') {
      this.preselectTraxCase(traxCaseFromParams.val(), traxCaseSelect);
    }
  }

  preselectTraxCase(traxCaseId, traxCaseSelect) {
    const loadingOption = new Option('Loading...', traxCaseId, true, true);
    traxCaseSelect.append(loadingOption).trigger('change');

    window.serverClient.timeEntries.getSelectedTraxCase({}, { trax_case_id: traxCaseId }).then((data) => {
      const newOption = new Option(data.trax_case.subject_with_id, data.trax_case.id, true, true);

      traxCaseSelect.append(newOption).trigger('change');

      traxCaseSelect.trigger({
        type: 'select2:select',
        params: {
          data: data
        }
      });
    });
  }
}
